import { Box, Grow, LinearProgress, Typography } from '@mui/material'
import { zIndex } from '@mui/system'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  box: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : theme?.custom?.palette.appBackground.main,
    zIndex: zIndex.snackbar,
  },
}))

const BoxAppLoader = ({ media, text, progressTitle, backgroundColor }) => {
  const { box } = useStyles({ backgroundColor })

  return (
    <Box display="flex" alignItems="center" justifyContent="center" className={box}>
      <Grow in>
        <Box display="inherit" flexDirection="column" alignItems="inherit">
          <Box display="inherit" alignItems="inherit" mb={1}>
            {media}
          </Box>
          <Box>
            <Typography align="center" variant="h3" component="p" gutterBottom>
              {text}
            </Typography>
            <LinearProgress title={progressTitle} />
          </Box>
        </Box>
      </Grow>
    </Box>
  )
}

BoxAppLoader.propTypes = {
  media: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  progressTitle: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
}

export default BoxAppLoader
